
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-cams",
      function () {
        return require("private-next-pages/surf-cams/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-cams"])
      });
    }
  